export const MainCameraPreviewConstant = { 
    START_LIVE_MAIN_CAMERA_PREVIEW: "START_LIVE_MAIN_CAMERA_PREVIEW",
    STOP_LIVE_MAIN_CAMERA_PREVIEW: "STOP_LIVE_MAIN_CAMERA_PREVIEW",
    UPDATE_LIVE_MAIN_CAMERA_PREVIEW: "UPDATE_LIVE_MAIN_CAMERA_PREVIEW", 
    FAILED_IN_LIVE_MAIN_CAMERA_PREVIEW_UPDATE: "FAILED_IN_LIVE_MAIN_CAMERA_PREVIEW_UPDATE"
 }